import { NgModule } from '@angular/core';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '../shared';

import { Event404Component } from './atoms';
import { OneDayLicensesComponent } from './ecosystems';
import { EventInformationComponent, LicenseStepProgressBarComponent } from './molecules';
import { OneDayRoutingModule } from './one-day-routing.module';
import {
  OneDayLicenseCartComponent,
  OneDayLicenseLandingComponent,
  OneDayLicenseMenuAccordionComponent,
  OneDayLicenseMenuComponent,
} from './organisms';

@NgModule({
  declarations: [
    // Atoms
    Event404Component,

    // Molecules
    EventInformationComponent,
    LicenseStepProgressBarComponent,

    // Organisms
    OneDayLicenseCartComponent,
    OneDayLicenseLandingComponent,
    OneDayLicenseMenuAccordionComponent,
    OneDayLicenseMenuComponent,

    // Ecosystems
    OneDayLicensesComponent,

    // ...modals,
  ],
  imports: [SharedModule, OneDayRoutingModule, NgbAlertModule],
})
export class OneDayModule {}
